import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { IErrorForm } from '../../interfaces';

@Component({
  selector: 'app-control-wrapper',
  templateUrl: './control-wrapper.component.html',
  styleUrls: ['./control-wrapper.component.scss'],
})
export class ControlWrapperComponent implements OnInit {
  @Input() public errors: IErrorForm;
  @Input() public errorsOverrideParams: any;
  @Input() public control: AbstractControl;
  @Input() public classGroup: string = '';
  @Input() public classHeader: string = '';
  @Input() public helper: string = '';
  @Input() public isShowHelper: boolean = true;

  constructor() {}

  public ngOnInit(): void {}
}
